import { StatscoreVizuConfig } from '../types';

export const statscoreVizuConfig: StatscoreVizuConfig = {
  liveApiKeys: {
    match: '68b031dcdb3659e88bb22a82',
    stats: '68b02fb1a9887e7eadf706db'
  },
  preApiKeys: {
    stats: '68aeefc5c580220453c71ab6'
  }
};
